import { render, staticRenderFns } from "./filePage.vue?vue&type=template&id=0ab6da61&scoped=true"
import script from "./filePage.vue?vue&type=script&lang=js"
export * from "./filePage.vue?vue&type=script&lang=js"
import style0 from "./filePage.vue?vue&type=style&index=0&id=0ab6da61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6da61",
  null
  
)

export default component.exports